export default {"src":"/_next/static/media/gray-square-meters.2d96d1de.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};